import React from "react";

export const publicRoutes = [
  {
    key: "Log In",
    path: "/",
    component: React.lazy(() => import("../../../View/AuthView/index")),
  },

  {
    key: "Reset Password",
    path: "/reset-password",
    component: React.lazy(
      () => import("../../../View/AuthView/ResetPassword/index")
    ),
  },
  {
    key: "Forget Password",
    path: "/forget-password",
    component: React.lazy(
      () => import("../../../View/AuthView/ForgetPassword/index")
    ),
  },
];

export const protectedRoutes = [
  {
    key: "Dashboard",
    path: "/dashboard",
    component: React.lazy(() => import("../../../pages/V2/Dashboard")),
  },
  {
    key: "Users",
    path: "/users",
    component: React.lazy(() => import("../../../pages/V2/Users")),
  },
  {
    key: "User Details",
    path: "/users/:id",
    component: React.lazy(() => import("../../../pages/V2/SingleUser")),
  },
  {
    key: "Providers",
    path: "/providers",
    component: React.lazy(() => import("../../../View/ProviderView/index")),
  },
  {
    key: "Manage Documents",
    path: "/manage-document",
    component: React.lazy(() => import("../../../View/ManageDocuments")),
  },
  {
    key: "Settings",
    path: "/settings",
    component: React.lazy(() => import("../../../View/SettingsView/index")),
  },
];
